import { Component, Input, OnInit, Output, ViewEncapsulation, EventEmitter, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as $ from 'jquery';
import { SearchEvent, SearchQueryModel } from '../../models/query.model';
import { SearchModel } from '../../models/search-model';
import { AppConfig } from '../../visa';
import { TimezoneUtils } from '../../models/timezone-utils';
import { FormControl } from '@angular/forms';

export let MARKETPLACE_BRANCHES = [
  'LAZADA ECOM SYNC BRANCH IZAN',
];

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvancedSearchComponent implements OnInit {
  @Input() advSearchModel: SearchModel;
  @Input() id: string;
  @Input() showAdv: boolean;
  @Input() readPermissionDefintion;
  @Input() enableTimezone: boolean = false;
  @Input() selectedTz: string;
  @Output() search = new EventEmitter<SearchQueryModel>();
  @Output() searchV2 = new EventEmitter<SearchEvent>();
  @Input() disableBasic: boolean = false;
  @Input() returnFormOnSubject = false;

  isAdvanced: boolean;
  inputArray: any[];
  advForm: FormGroup;
  optionArray = {};
  filter = '';
  basicSearchQuery = '';
  apiVisa = AppConfig.apiVisa;
  
  constructor(private formBuilder: FormBuilder) {
    this.isAdvanced = false;
    if (!this.showAdv) {
      this.showAdv = true;
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent): void {
    this.isAdvanced = false;
  }

  ngOnInit() {
    this.advForm = this.advSearchModel.form;
    this.inputArray = Object.entries(this.advSearchModel.dataType).map((e: any) => e.flatMap(f => f));
    this.extractOptions();
    // this.addCheckbox();

    $(document).mouseup( ev => {
      const container = $(`#${this.id}`);
      const calendar = $('mat-calendar');
      const matOption = $('mat-option');
      const backdrop = $('.cdk-overlay-backdrop');
      if (!matOption.is(ev.target) && !calendar.is(ev.target) && !container.is(ev.target) && !backdrop.is(ev.target)
          && matOption.has(ev.target).length === 0
          && container.has(ev.target).length === 0
          && calendar.has(ev.target).length === 0
          && backdrop.has(ev.target).length === 0) {
        container.hide('fast' , 'swing', c => {
          this.isAdvanced = false;
          // this.advForm.reset();
        });
      }
    });
  }

  extractOptions = (fieldName?, fieldValue?) => this.inputArray
  .filter(x => (x[1] === 'select' || x[1] === 'multiSelect' || x[1] === 'orderBy'))
  .filter(x => fieldName ? x[0] === fieldName : true)
  .forEach(x => {
    if (Array.isArray(x[2])) {  
      const options = x[2]
        .flatMap(e => e)
        .filter(e => fieldValue ? e.toLowerCase().includes(fieldValue.toLowerCase()) : true);
      this.optionArray[x[0]] = options;
    } else {
      console.warn(`Unexpected value for x[2]: `, x[2]);  // Log if x[2] is undefined or not an array
    }
  });


  searchToggle() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      container.show('fast', 'swing', c => this.isAdvanced = true);
    }
  }

  reset() {
    // this.buildQueryString('');
    // this.basicSearchQuery = '';
    this.advForm.reset();
    // this.search.emit(query);
  }

  optionSearchFilter(query) {
    const fieldName = query.target.parentNode.parentNode.id;
    this.extractOptions(fieldName, query.target.value);
  }

  /**
   * joins = [{type of join, table name, alias name of table, on condition}]
   *
   * @param specify any where conditions
   * @param specify any joins
   * @returns the full sql query
   */
  buildQueryString(conditions: string, joins?, keyword?) {
    let queryStr =
    `SELECT (hdr.guid) as requiredGuid
    FROM ${this.advSearchModel.table} as hdr`;

    // conditions for join
    if (joins) {
      joins.forEach(join => queryStr = join ? queryStr + `
      ${join.type} ${join.table} as ${join.alias} on ${join.onCondition}` : '');
    }

    const whereConditions = conditions ? `WHERE ${conditions}` : '';
    const query = {
      queryString: `
      ${queryStr}
      ${whereConditions}
      `,
      keyword: keyword,
      isEmpty: !conditions,
      table: this.advSearchModel.table
    };

    return query;
  }

  queryBuilder() {
    let conditions = '';
    // const basicQuery = this.basicSearchQuery ? `(${this.advSearchModel.query(this.basicSearchQuery)})` : '';
    const basicQuery = `${this.advSearchModel.query(this.basicSearchQuery)}`;
    if (this.advForm.dirty) {
      const queries = Object
      .entries(this.advSearchModel.queryCallbacks)
      .map(([prop, callbackfn]: [string, (any) => string]) => callbackfn(this.advForm.value[prop]));
      const additionalCs = this.advSearchModel.additionalCondition ?? '';
      conditions = [basicQuery, ...queries, additionalCs]
        .filter(q => q !== '')
        .reduce((p, c) => `${p} AND ${c}\n`);
    }

    if (this.advSearchModel.hasOwnProperty('joins')) {
      return this.buildQueryString(conditions, this.advSearchModel.joins);
    }
    return this.buildQueryString(conditions);
  }

  basicSearch(e: string) {
    if (this.returnFormOnSubject) {
      this.emitSearchEvent(true, e.trim());
      return;
    }
    const conditions = e ? this.advSearchModel.query(e) : '';
    let joins = null;
    // only join the necessary tables on basic search
    if (this.advSearchModel.hasOwnProperty('joins')) {
      const joinsOnBasic = this.advSearchModel.joins.filter(join => join.joinOnBasic);
      joins = joinsOnBasic.length > 0 ? joinsOnBasic : null;
    }
    const query = this.buildQueryString(conditions, joins, e);
    this.search.emit(query);
  }

  advancedSearch() {
    const container = $(`#${this.id}`);
    if (this.returnFormOnSubject) {
      this.emitSearchEvent(false);
    } else {
      const query = this.queryBuilder();
      this.search.emit(query);
    }
    container.hide('fast' , 'swing', c => {
      this.isAdvanced = false;
      // this.advForm.reset();
    });
  }

  isTrue(value) {
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  isMultiple(x) {
    let value = this.advSearchModel.options[x[0]]['multiple'];
    return this.isTrue(value);
  }

  isCheckbox(x) {
    let value = this.advSearchModel.options[x[0]]['checkbox'];
    return this.isTrue(value);
  }

  addCheckbox() {
    this.inputArray.forEach(x => {
      if (this.isCheckbox(x)) {
        const checkbox = this.formBuilder.control(false);
        const name = x[0] + 'Checkbox';
        this.advForm.addControl(name, checkbox);
      }
    })
  }

  dateChange(newDate: moment.Moment, control: FormControl, selectedTz?: string) {
    if (this.enableTimezone && this.selectedTz) TimezoneUtils.formControlDateChange(newDate, control, selectedTz);
  }

  emitSearchEvent(basicSearchMode: boolean, query?: string) {
    const formValues = { ...this.advForm.value };
    const isEmpty = basicSearchMode 
      ? !query ? true : false
      : Object.values(formValues).flatMap(e => e).every(val => !val ? true : false);
    const searchEvent: SearchEvent = {
      isEmpty,
      basicSearchMode,
      basicQuery: basicSearchMode ? query : null, 
      form: formValues,
    };
    this.searchV2.emit(searchEvent);
  }
}
